const CardLayout = ({ className, children }) => {
  return (
    <div className={`card card-body rounded ${className}`}>{children}</div>
  );
};

export default CardLayout;
